import { CurrentPageTitleActionTypes } from '../types';
import { SET_CURRENT_PAGETITLE } from '../constants/actionTypes';
import { PageKeys } from '../reducers/filterSortReducer';

export const setCurrentPageTitle = (pageTitle: PageKeys): CurrentPageTitleActionTypes => ({
  type: SET_CURRENT_PAGETITLE,
  payload: pageTitle,
});
